import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { process } from "@progress/kendo-data-query";
import {
  Container,
  Row,
  Col,
  Label,
  Form,
} from "reactstrap";

import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { ColumnMenu } from '../components/kendoComponents/columnMenu/ColumnMenu';
import { ColumnProps } from '../components/kendoComponents/columnProps/ColumnProps';
import { GridPager } from "../components/kendoComponents/gridPager/GridPager";
import "../assets/scss/kendo-theme-custom.scss";
import moment from "moment";


import "react-hammerjs";


import LoaderSpin from "../components/loaderSpin/LoaderSpin";

import { useNavigate } from "react-router-dom";
import IssueTypesSelector from "../components/DataQuality/IssueTypesSelector";

import FilterMese from "../components/DataQuality/FilterMese";
import FilterSubmit from "../components/DataQuality/FilterSubmit";
import { fetchDQIssues } from "../store/app/ProcessRuns/ProcessRunsSlice";
import { DateCell } from "../components/kendoComponents/dateCell/DateCell";
import FilterOverlay from "../components/filterOverlay/FilterOverlay";
import AtlanCell from "../components/customRender/renders/Renders";

import PropTypes from "prop-types";


const VersionCell = (props) => {
  const { dataItem, navigate, searchParams } = props;


  return (
    <td>
      <button
        type="button"
        style={{ cursor: "pointer", background: "none", border: "none", padding: 0 }}
        className="fw-bold text-decoration-underline"
        onClick={() => navigate(
          "/versioni/detail/" +
          dataItem.version_id +
          "?" +
          searchParams
        )}
        onKeyDown={() => navigate(
          "/versioni/detail/" +
          dataItem.version_id +
          "?" +
          searchParams
        )}
        tabIndex={0}
        aria-label={`Go to version ${dataItem.version_id}`}
      >
        {dataItem.version_id}
      </button>
    </td>
  )
};

VersionCell.propTypes = {
  dataItem: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const BooleanCell = ({ props, field, value1 = "Yes", value2 = "No" }) => {
  const { dataItem } = props;
  const value = dataItem[field];
  return <td>{value ? value1 : value2}</td>;
};

BooleanCell.propTypes = {
  props: PropTypes.object.isRequired,
  dataItem: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  value1: PropTypes.string,
  value2: PropTypes.string,
};

const DataQualityIssueReport = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);

  const isSpinnerVisible = useSelector((state) => state.dataQualityReducer.loading);
  const dataCheck = useSelector((state) => state.dataQualityReducer.dataCheck);
  const refreshCount = useSelector((state) => state.dataQualityReducer.refreshCount)

  const fileterDQIssueTypes = useSelector((state) => state.processRunsReducer.filterDQIssueTypes);
  const dqIssues = useSelector((state) => state.processRunsReducer.dqIssues);
  const filterMese = useSelector((state) => state.dataQualityReducer.filterMese)


  const [dataState, setDataState] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ], skip: 0, take: 20
  });

  const [dataResult, setDataResult] = useState(
    process(dqIssues, dataState)
  );

  useEffect(() => {
    dispatch(fetchDQIssues(filterMese, fileterDQIssueTypes))
  }, [navigate, refreshCount]);

  useEffect(() => {
    setDataResult(process(dqIssues, dataState));
  }, [dqIssues])

  const renderVersionCell = (props) => {
    return <VersionCell {...props} navigate={navigate} searchParams={searchParams} />;
  };

  const renderBooleanCell = (props, field, value1 = "Yes", value2 = "No") => {
    return <BooleanCell props={props} field={field} value1={value1} value2={value2} />;
  };

  return (
    <>
            <Form>
        <Row className="bg-light-primary px-4 py-2">
          <Col>
            <Row className="align-items-end g-2">
              <Col xs="12" sm="auto" className="flex-grow-1">
                <Label for="categoryName" className="mb-1 small">Month Report</Label>
                <FilterMese />
              </Col>
              
              <Col xs="12" sm="auto" className="flex-grow-1">
                <Label for="categoryName" className="mb-1 small">DQ Issue type</Label>
                <IssueTypesSelector />
              </Col>

              <Col xs="12" sm="auto" className="d-flex align-items-end ms-sm-auto">
                <FilterSubmit color="primary" text="Filter" />
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
      
      <Container fluid className="py-2 px-4  position-relative ">
        <p className="my-2 lh-sm">
          Generato il {moment().format("D/M/Y")} alle {moment().format("H:m:s")}
          . DQ-Issuses totali: {dqIssues.length}.
        </p>
        <Row>
          <Col>
            <div className="grid_task_container_tabs border overflow-x-scroll position-relative">
              <div className="position-absolute w-100 h-100 top-0 start-0">
                <Grid
                  style={{ height: "100%" }}
                  scrollable="scrollable"
                  fixedScroll={true}
                  pageable={true}
                  sortable={true}
                  total={dataResult?.length}
                  data={dataResult}
                  pager={(props) => GridPager(props, dqIssues, 'dq_issue_report_')}
                  {...dataState}
                  groupable={true}
                  onDataStateChange={(e) => {
                    setDataState(e.dataState);
                    setDataResult(process(dqIssues, e.dataState));
                  }}
                >
                  <Column
                    {...ColumnProps("issue_type_name", dataState)}
                    title="Data quality issue type"
                    columnMenu={ColumnMenu}
                    width="300px"
                  />
                  <Column
                    {...ColumnProps("version_id", dataState)}
                    title="Version ID"
                    columnMenu={ColumnMenu}
                    width="150px"
                    cell={renderVersionCell}
                  />
                  <Column
                    {...ColumnProps("product_name", dataState)}
                    title="Data product type name"
                    columnMenu={ColumnMenu}
                    width="200px"
                    cell={(props) => AtlanCell(props, "product_name", "type_id")} />
                  <Column
                    {...ColumnProps("reference_date", dataState)}
                    title="Reference Date"
                    columnMenu={ColumnMenu}
                    cell={(props) => DateCell(props, false)}
                    width="200px"
                  />
                  <Column
                    {...ColumnProps("status_name", dataState)}
                    title="Version Status"
                    columnMenu={ColumnMenu}
                    width="200px"
                  />
                  <Column
                    {...ColumnProps("creation_ts", dataState)}
                    title="Creation Date"
                    columnMenu={ColumnMenu}
                    minResizableWidth={200}
                  />
                  <Column
                    {...ColumnProps("validation_ts", dataState)}
                    title="Validation Timestamp"
                    columnMenu={ColumnMenu}
                    cell={(props) => DateCell(props, true)}
                    width="200px"
                  />
                  <Column
                    {...ColumnProps("is_manual_validation", dataState)}
                    title="Validation Type"
                    columnMenu={ColumnMenu}
                    width="200px"
                    cell={(props) => renderBooleanCell(props, "is_manual_validation", "Manual", "Automatic")}
                  />
                  <Column
                    {...ColumnProps("validation_user", dataState)}
                    title="Validation User"
                    columnMenu={ColumnMenu}
                    width="200px"
                  />
                  <Column
                    {...ColumnProps("domain_name", dataState)}
                    title="Domain"
                    columnMenu={ColumnMenu}
                    width="200px"
                  />
                </Grid>
              </div>
            </div>
          </Col>
        </Row>
        <LoaderSpin isVisible={isSpinnerVisible} />
        <FilterOverlay isVisible={dataCheck} />
      </Container>
    </>
  );
};

export default DataQualityIssueReport;
